export default __webpack_public_path__ + "static/createreserved-f303de8a4795a85a202ad6b74b97ad4f.png";